/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * ReferringParamsBase
 * auto generated base class for the model ReferringParamsModel.
 */
export const ReferringParamsModelBase = ModelBase.named('ReferringParams')
  .props({
    __typename: types.optional(types.literal('ReferringParams'), 'ReferringParams'),
    _id: types.identifier,
    childUserId: types.union(types.undefined, types.null, types.frozen()),
    createdAt: types.union(types.undefined, types.frozen()),
    installParams: types.union(types.undefined, types.null, types.frozen()),
    latestParams: types.union(types.undefined, types.null, types.frozen()),
    parentUserId: types.union(types.undefined, types.null, types.frozen()),
    uniqueId: types.union(types.undefined, types.null, types.number),
    updatedAt: types.union(types.undefined, types.frozen())
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ReferringParamsModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get childUserId() {
    return this.__attr('childUserId')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get installParams() {
    return this.__attr('installParams')
  }
  get latestParams() {
    return this.__attr('latestParams')
  }
  get parentUserId() {
    return this.__attr('parentUserId')
  }
  get uniqueId() {
    return this.__attr('uniqueId')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
}
export function selectFromReferringParams() {
  return new ReferringParamsModelSelector()
}

export const referringParamsModelPrimitives =
  selectFromReferringParams()._id.childUserId.createdAt.installParams.latestParams.parentUserId.uniqueId.updatedAt
